
export interface Audit {
	id: string | null;
	user?: {
	  id: string;
	  name: string;
	  [key: string]: any; // for any additional dynamic fields
	};
	values_json: any | null;
	created_by: string | null;
	created_at: string | null;
	updated_at: string | null;
	deleted_at: string | null;
	staff_name: string;
	shift: string;
	summary: Summary;
	remarks: string[];
	hourly_logs: HourlyActivityLog[];
}

export interface ActivityEntry {
	timestamp: string;
	type: string;
	action: string;
	time_spent?: string | null;
	details: string;
	points: number;
	gap?: string | null;
	model?: string;
	child_model?: string;
	child_record?: string;
	record?: string;
	record_name?: string;
  }
  

export interface HourlyActivityLog {
	hour_range?: string;
	points: number;
	leads: number;
	activities: number;
	logs: ActivityEntry[];
  }

export interface Metrics {
	total_points: number;
	total_leads: number;
	total_activities: number;
}

export interface Summary {
	individual: Metrics;
	team: Metrics;
}

export interface AuditSummary {
    date: string;
    user: { id: string, name: string };
    role: { id: string, name: string };
    team: { id: string, name: string } | null;
    check_in_time: string | null;
    check_out_time: string | null;
    remarks: string[];
    points: number | null;
    leads: number | null;
    activities: number | null;
}

export enum AuditActionTypes {
  GET_AUDIT_REQUEST = "@@audit/GET_AUDIT_REQUEST",
  GET_AUDIT_SUCCESS = "@@audit/GET_AUDIT_SUCCESS",
  GET_AUDIT_ERROR = "@@audit/GET_AUDIT_ERROR",
  GET_AUDIT_SUMMARY_REQUEST = "@@audit/GET_AUDIT_SUMMARY_REQUEST",
  GET_AUDIT_SUMMARY_SUCCESS = "@@audit/GET_AUDIT_SUMMARY_SUCCESS",
  GET_AUDIT_SUMMARY_ERROR = "@@audit/GET_AUDIT_SUMMARY_ERROR",
}

export interface AuditState {
  readonly details: Audit | null;
  readonly loading: boolean;
  readonly summaries: AuditSummary[] | null;
  readonly summariesLoading: boolean;
}
